import { useTranslation } from 'react-i18next';

import { MultiSelectField as MultiSelectElement, TextField as TextFieldElement } from 'Common/Form';

import { ParticipantFieldContainer, ParticipantsRow } from '../styled';

type Props = {
  hasAttemptedSubmit: boolean;
  formValidationErrors: Record<string, string>;
  datacenterOptions: Array<{ id: string; label: string; description: string }>;
};

export const ParticipantsSection = ({
  hasAttemptedSubmit,
  formValidationErrors,
  datacenterOptions
}: Readonly<Props>) => {
  const { t } = useTranslation();

  return (
    <ParticipantsRow>
      <ParticipantFieldContainer>
        <TextFieldElement
          name="expectedParticipants"
          label={t('courseForm.expectedParticipants')}
          type="number"
          fullWidth
          error={hasAttemptedSubmit && !!formValidationErrors.expectedParticipants}
          helperText={hasAttemptedSubmit ? formValidationErrors.expectedParticipants : ''}
        />
      </ParticipantFieldContainer>

      <ParticipantFieldContainer>
        <TextFieldElement
          name="maxParticipants"
          label={t('courseForm.maxParticipants')}
          type="number"
          required
          fullWidth
          error={hasAttemptedSubmit && !!formValidationErrors.maxParticipants}
          helperText={hasAttemptedSubmit ? formValidationErrors.maxParticipants : ''}
        />
      </ParticipantFieldContainer>

      <ParticipantFieldContainer>
        <MultiSelectElement
          name="daDataCenterIds"
          label={t('courseForm.dataCenter')}
          options={datacenterOptions}
          fullWidth
        />
      </ParticipantFieldContainer>
    </ParticipantsRow>
  );
};
